import { FormControl, MenuItem, Select } from '@mui/material';
import { sortBy } from "lodash";
import React from 'react';

export default React.forwardRef(function LookupFieldRef(props, forwardedRef) {
    const entries = sortBy(
        Object.entries(props.columnDef.lookup).map(entry => ({ value: entry[0], label: entry[1] })),
        ['label', 'value']
    );

    const options = entries.map(entry => {
        return (
            <MenuItem key={entry.value} value={entry.value}>
                {entry.label}
            </MenuItem>
        );
    });

    return (
        <FormControl ref={forwardedRef} error={Boolean(props.error)}>
            <Select
                {...props}
                value={props.value === undefined ? '' : props.value}
                onChange={(event) => props.onChange(event.target.value)}
                style={{
                    fontSize: 13
                }}
                SelectDisplayProps={{ 'aria-label': props.columnDef.title }}
            >
                {options}
            </Select>
        </FormControl>
    );
});